import { translate, useLocale } from "../../localization";
import { Link } from "react-router-dom";
import "./PricingLink.scss";

const PricingLink = ({ }) => {
  useLocale();
  return(
    <Link className="header-link" to="/pricing">{translate("Pricing")}</Link>
  )
}

export default PricingLink;